var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499634 10C0.499634 14.2997 3.21338 17.9651 7.02139 19.3781V0.62207C3.21338 2.03496 0.499634 5.70043 0.499634 10Z",
    fill: "#00874C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10C20.5 5.70043 17.7862 2.03496 13.9782 0.62207V19.3781C17.7862 17.9651 20.5 14.2997 20.5 10Z",
    fill: "#00874C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNig);
export default __webpack_public_path__ + "static/media/nig.71de8d573de1a455c43a148646baaa87.svg";
export { ForwardRef as ReactComponent };